import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import style from "../../Assets/css/b2bClientCarousel.module.css";

import clientLogo from "../../Assets/img/b2b/clients-logo.png";
function ClientCarousel() {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(selectedIndex);
	};
	return (
		<div style={{ background: "#fff" }}>
			<div style={{ marginTop: "-10vh" }}>
				<br />
				<div style={{ margin: "5%", textAlign: "center" }}>
					<h2>Our Clients</h2>
					<p>
						<b>Product Companies </b>our Students are Placed In
					</p>
				</div>
				<Carousel
					className={style["carousel-indicators"]}
					controls={false}
					style={{ paddingBottom: "5%", zIndex: "0" }}
					// prevIcon={<span aria-hidden="false" className="carousel-control-prev-icon" />}
					activeIndex={index}
					onSelect={handleSelect}
				>
					<Carousel.Item
						className={style[("carousel-indicators", "active")]}
					>
						<div
						//   style={{
						//     display: "flex",
						//     marginTop: "4%",
						//     justifyContent: "center",
						//   }}
						>
							<img
								style={{
									objectFit: "contain",
									position: "relative",
									width: "100%",
								}}
								src={clientLogo}
								alt=""
							/>
						</div>

						<Carousel.Caption
							style={{ color: "black" }}
						></Carousel.Caption>
					</Carousel.Item>
					<Carousel.Item className={style["active"]}>
						<div
						//   style={{
						//     display: "flex",
						//     marginTop: "4%",
						//     justifyContent: "center",
						//   }}
						>
							<img
								style={{
									objectFit: "contain",
									position: "relative",
									width: "100%",
								}}
								src={clientLogo}
								alt=""
							/>
						</div>

						<Carousel.Caption
							style={{ color: "black" }}
						></Carousel.Caption>
					</Carousel.Item>{" "}
					<Carousel.Item
						className={style[("carousel-indicators", "active")]}
					>
						<div
						//   style={{
						//     display: "flex",
						//     marginTop: "4%",
						//     justifyContent: "center",
						//   }}
						>
							<img
								style={{
									objectFit: "contain",
									position: "relative",
									width: "100%",
								}}
								src={clientLogo}
								alt=""
							/>
						</div>

						<Carousel.Caption
							style={{ color: "black" }}
						></Carousel.Caption>
					</Carousel.Item>
				</Carousel>
			</div>
		</div>
	);
}

export default ClientCarousel;
